import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import * as Common from '_common';
import { useWidgetRegister } from '_frameRegister';
import * as React from 'react';
export function StateFrames() {
    const frameRegister = Common.useFrameRegister();
    const spaContext = Common.useSpaContext();
    React.useEffect(() => {
        if (frameRegister && spaContext) {
            const processes = spaContext.process ?? {};
            for (const process of Object.keys(processes)) {
                const processInfo = processes[process];
                const existingFrame = frameRegister.frame(process);
                if (processInfo && processInfo !== 'null') {
                    if (!existingFrame) {
                        const frame = {
                            id: process,
                            title: processInfo.name || 'Process',
                            component: {
                                type: 'Process',
                                properties: { id: process },
                            },
                        };
                        frameRegister.register(frame);
                    }
                }
                else {
                    if (existingFrame) {
                        frameRegister.remove(process);
                    }
                }
            }
        }
    }, [frameRegister, spaContext]);
    return _jsx(_Fragment, {});
}
export const WidgetsContext = React.createContext([
    [],
    () => { },
]);
export function useWidgets() {
    const context = React.useContext(WidgetsContext);
    if (!context) {
        throw new Error('useWidgets must be used within a WidgetProvider');
    }
    return context;
}
export function WidgetProvider(props) {
    const widgetDefinitions = useWidgetRegister();
    const [widgets, setWidgets] = React.useState([]);
    React.useEffect(() => {
        // TODO load widget placements
        setWidgets(widgetDefinitions);
    }, [widgetDefinitions]);
    const updatePlacement = (id, placement, remove) => {
        setWidgets(widgets => {
            // TODO fix this
            if (remove) {
                return widgets.filter(w => w.id !== id);
            }
            return widgets;
        });
        // TODO save widget placements
    };
    return (_jsx(WidgetsContext.Provider, { value: [widgets, updatePlacement], children: props.children }));
}
